<template>
  <section class="phase-list">
    <LineText :title="data.lineText" />
    <div class="c-container c-container--small">
      <ul class="phase-list__list">
        <li
          class="list__item"
          v-for="(item, i) in data.list"
          :key="i"
        >
          <p class="item__number">{{ `0${ i + 1 }` }}</p>
          <h4 class="item__title" data-anim="title">{{ item.title }}</h4>
          <p
            v-if="item.content !== undefined"
            class="item__content"
            data-anim="paragraph"
          >
            {{ item.content }}
          </p>
          <span
            v-if="i !== (data.list.length - 1)"
            class="item__line"
          ></span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import LineText from '@/components/LineText.vue';

export default {
  name: 'PhasesList',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  components: {
    LineText,
  },
};
</script>

<style lang="scss" scoped>
.phase-list {
  .list__item {
    position: relative;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  .item {
    &__number {
      position: absolute;
      left: -60px;

      color: $color-red;
      font-family: 'Apercu';
    }

    &__title {
      width: calc(30% - 80px);
      flex: 1 1 calc(30% - 80px);
    }

    &__content {
      width: calc(70% - 80px);
      flex: 0 0 calc(70% - 80px);
    }

    &__line {
      display: block;

      width: 100%;
      height: 1px;
      background-color: lighten($color-dark, 70%);
      margin: 40px 0;
    }
  }
}
</style>
